var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.indicators.length)?_c('div',{staticClass:"my-3 d-flex scroll hide-scrollbar"},_vm._l((_vm.indicators),function(indicator){return _c('IndicatorSmall',{key:indicator.id,attrs:{"title":indicator.title,"value":indicator.count}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }